/**
 * Trade Application Form
 * - Client-side validation + conditional "Other" field
 * - Assembles all field data into the hidden contact[body] field
 * - Lets Shopify handle the actual form submission natively
 */
(function () {
  'use strict';

  var FORM_ID = 'TradeApplicationForm';

  function init() {
    var form = document.getElementById(FORM_ID);
    if (!form) return;

    var otherField = form.querySelector('[data-other-field]');
    var businessTypeSelect = form.querySelector('[name="contact[business_type]"]');

    // Toggle "Other" field visibility
    if (businessTypeSelect && otherField) {
      businessTypeSelect.addEventListener('change', function () {
        otherField.hidden = this.value !== 'Other';
        if (this.value !== 'Other') {
          var input = otherField.querySelector('input');
          if (input) input.value = '';
        }
      });
    }

    form.addEventListener('submit', handleSubmit);
  }

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function handleSubmit(e) {
    var form = e.target;

    // Honeypot check
    var hp = form.querySelector('[name="contact[address_confirm]"]');
    if (hp && hp.value) { e.preventDefault(); return; }

    // Clear previous errors
    form.querySelectorAll('.trade-form__field--error').forEach(function (el) {
      el.classList.remove('trade-form__field--error');
    });

    // Validate required fields
    var valid = true;
    form.querySelectorAll('[data-required]').forEach(function (input) {
      if (!input.value.trim()) {
        valid = false;
        var field = input.closest('.trade-form__field');
        if (field) field.classList.add('trade-form__field--error');
      }
    });

    // Validate email format
    var emailInput = form.querySelector('[name="contact[email]"]');
    if (emailInput && emailInput.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
      valid = false;
      var emailField = emailInput.closest('.trade-form__field');
      if (emailField) {
        emailField.classList.add('trade-form__field--error');
        var errorEl = emailField.querySelector('.trade-form__error');
        if (errorEl) errorEl.textContent = 'Please enter a valid email address';
      }
    }

    // Conditional: if "Other" is selected, require the specify field
    var businessType = val(form, 'contact[business_type]');
    if (businessType === 'Other') {
      var otherInput = form.querySelector('[name="contact[business_type_other]"]');
      if (otherInput && !otherInput.value.trim()) {
        valid = false;
        var otherField = otherInput.closest('.trade-form__field');
        if (otherField) otherField.classList.add('trade-form__field--error');
      }
    }

    if (!valid) {
      e.preventDefault();
      var firstError = form.querySelector('.trade-form__field--error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Assemble all fields into the hidden contact[body] field
    var lines = [
      '--- TRADE ACCOUNT APPLICATION ---',
      '',
      'Full Name: ' + val(form, 'contact[name]'),
      'Email: ' + val(form, 'contact[email]'),
      'Phone: ' + val(form, 'contact[phone]'),
      'Company: ' + val(form, 'contact[company]'),
      'Website: ' + (val(form, 'contact[website]') || 'Not provided'),
      'VAT Number: ' + (val(form, 'contact[vat_number]') || 'Not provided'),
      'Business Type: ' + businessType
    ];

    if (businessType === 'Other') {
      lines.push('Business Type (Other): ' + val(form, 'contact[business_type_other]'));
    }

    lines.push(
      'Estimated Annual Spend: ' + (val(form, 'contact[annual_spend]') || 'Not provided'),
      '',
      'Business Description:',
      (val(form, 'contact[business_description]') || 'Not provided'),
      '',
      'How did you hear about us: ' + (val(form, 'contact[referral_source]') || 'Not provided'),
      '',
      '--- END OF APPLICATION ---'
    );

    // Write the assembled body into the hidden field
    var bodyField = form.querySelector('#trade-body');
    if (bodyField) bodyField.value = lines.join('\n');

    // Show loading state (form will submit natively and reload the page)
    var submitBtn = form.querySelector('.trade-form__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('trade-form__submit--loading');
      var label = submitBtn.querySelector('.trade-form__submit-label');
      if (label) label.textContent = 'Submitting\u2026';
    }

    // Allow the native form submission to proceed (no e.preventDefault())
  }

  // FAQ accordion — only one open at a time
  function initFAQ() {
    document.querySelectorAll('.trade-faq__item').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (this.open) {
          document.querySelectorAll('.trade-faq__item[open]').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initFAQ(); });
  } else {
    init();
    initFAQ();
  }
})();
